import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import { useUserRoles } from "../../hooks/useUserRoles";
import { isWorkspaceAdmin } from "../../utils/authorization";
import PrepJobListPage from "./ui/PrepJobListPage";
import AdminPrepJobsPage from "./ui/AdminPrepJobsPage";

/** Data prep jobs plus, for workspace admins, the approval queue for their output indices. */
const DataPrep = () => {
  const { t } = useTranslation();
  const roles = useUserRoles();
  const canApprove = isWorkspaceAdmin(roles);
  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "jobs",
        label: t("hub.dataPrep.jobs"),
        icon: <AccountTreeOutlinedIcon fontSize="small" />,
        render: () => <PrepJobListPage />,
      },
      {
        key: "approvals",
        label: t("prep.admin.approvalsTab"),
        icon: <FactCheckOutlinedIcon fontSize="small" />,
        visible: canApprove,
        render: () => <AdminPrepJobsPage />,
      },
    ],
    [t, canApprove]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("menu.data-prep")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default DataPrep;
